import React, { Component } from "react";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";
import Select from "react-select";
import { Alert, Card, CardBody, CardHeader, Col, Label, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import { layout, messages, roles } from "../../../../common/constants";
import { formatHelper } from "../../../../common/helpers";
import { DataTable, ExportCSV } from "../../../../components";
import {
  getCategoryBalance as categoriesBalanceExport,
  getCategorySellsBalance as categoriesBalanceDetailedExport,
} from "../../../../service/report";
import {
  getCategoryBalance,
  getCategorySellsBalance,
} from "../../../../store/report/actions";
import { selectCategoryBalance } from "../../../../store/report/selector";
import { getStores } from "../../../../store/store/actions";
import { selectStoresForSelect } from "../../../../store/store/selector";
import { selectUserRole } from "../../../../store/user/selector";
import * as columns from "./_columns";
import { toast } from "react-toastify";
import { exportExcel, exportExcelGeneral } from "./excel";
class CategoryBalance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: null,
      startDate: null,
      endDate: null,
      focusedInput: null,
      page: 1,
      pageSells: 1,
      loadingExport: false,
      selectedStore: null,
      hasChangeToPerform: false,
      hasChangeToPerformSells: false,
    };
    this.handleStoreChange = this.handleStoreChange.bind(this);

    this.handleObtainReportExport = this.handleObtainReportExport.bind(this);

    this.handleObtainDetailedReportExport =
      this.handleObtainDetailedReportExport.bind(this);

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSellsPageChange = this.handleSellsPageChange.bind(this);
  }

  handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    this.setState({
      selectedStore: value,
      page: 1,
      pageSells: 1,
      hasChangeToPerform: true,
      hasChangeToPerformSells: true,
    });
  }

  async componentDidMount() {
    this.props.getStores({ reset: true });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }

    if (
      prevState.hasChangeToPerform != this.state.hasChangeToPerform &&
      this.state.hasChangeToPerform
    ) {
      this.setState({ hasChangeToPerform: false });
      this.performGetCategoryBalance();
    }
    if (
      prevState.hasChangeToPerformSells != this.state.hasChangeToPerformSells &&
      this.state.hasChangeToPerformSells
    ) {
      this.setState({ hasChangeToPerformSells: false });
      this.performGetCategorySellsBalance();
    }
  }

  async handleCategoryBalanceDateChange(startDate, endDate) {
    this.setState({
      startDate,
      endDate,
      hasChangeToPerform: true,
      hasChangeToPerformSells: true,
      page: 1,
      pageSells: 1,
    });
  }

  performGetCategoryBalance(reset = false) {
    const { getCategoryBalance } = this.props;
    const { page, startDate, endDate } = this.state;
    const store = this.state.selectedStore.value;

    if (startDate == null || endDate == null) return;

    getCategoryBalance({
      page,
      startDate: startDate._d,
      endDate: endDate._d,
      store,
      reset,
    });
  }

  performGetCategorySellsBalance(reset = false) {
    const { getCategorySellsBalance } = this.props;
    const { pageSells, startDate, endDate } = this.state;
    const store = this.state.selectedStore.value;

    if (startDate == null || endDate == null) return;

    getCategorySellsBalance({
      page: pageSells,
      startDate: startDate._d,
      endDate: endDate._d,
      store,
      reset,
    });
  }

  handlePageChange(page) {
    this.setState({ page: page, hasChangeToPerform: true });
  }

  handleSellsPageChange(page) {
    this.setState({ pageSells: page, hasChangeToPerformSells: true });
  }

  renderDataTable(
    columns,
    data,
    page,
    total,
    pageSize,
    loading,
    handlePageChange
  ) {
    return (
      <DataTable
        data={data}
        keyField="id"
        columns={columns}
        page={page}
        totalSize={total}
        sizePerPage={pageSize}
        loading={loading}
        onPageChange={handlePageChange}
      />
    );
  }

  handleObtainDetailedReportExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    categoriesBalanceDetailedExport(
      0,
      startDate._d,
      endDate._d,
      selectedStore.value
    )
      .then((response) => {
        exportExcel(response.data.data, selectedStore, startDate, endDate);
      })
      .catch(() => {
        toast.error("Ocurrió un problema al generar el reporte detallado.");
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  handleObtainReportExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    categoriesBalanceExport(0, startDate._d, endDate._d, selectedStore.value)
      .then((response) => {
        exportExcelGeneral(
          response.data.data,
          selectedStore,
          startDate,
          endDate
        );
      })
      .catch(() => {
        toast.error("Ocurrió un problema al generar el reporte.");
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const { startDate, endDate } = this.state;

    const {
      categorySells,
      categorySellsLoading,
      categorySellsTotal,
      categorySellsPageSize,
      totalBought,
      categorySellsError,
      categoryBalance,
      categoryBalanceTotal,
      categoryBalancePageSize,
      categoryBalanceError,
      categoryBalanceLoading,
    } = this.props;
    return (
      <div>
        <Card>
          <CardHeader>
            <i className="icon-chart"></i>Balance por Categorías
          </CardHeader>
          <CardBody>
            <div>
              {(this.props.role == roles.SUPER_ADMIN ||
                this.props.role == roles.ADMIN) && (
                <Row className="my-4">
                  <Col sm="1">
                    <Label className="mt-2">Tienda:</Label>
                  </Col>

                  <Col sm="4">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isLoading={this.props.loadingStores}
                      isSearchable={true}
                      noOptionsMessage={() => {
                        return messages.SELECT_NO_OPTIONS;
                      }}
                      placeholder=""
                      options={this.props.stores}
                      loadingMessage={() => {
                        return messages.SELECT_LOADING;
                      }}
                      onChange={this.handleStoreChange}
                      value={this.state.selectedStore}
                      isDisabled={
                        this.props.loadingStores ||
                        categorySellsLoading ||
                        categoryBalanceLoading
                      }
                    />
                  </Col>
                </Row>
              )}

              <Row className="mb-2">
                <Col md="5">
                  <DateRangePicker
                    startDate={startDate}
                    startDateId="startDate"
                    endDate={endDate}
                    endDateId="endDate"
                    displayFormat={"DD/MM/YYYY"}
                    disabled={
                      this.props.loadingStores ||
                      categorySellsLoading ||
                      categoryBalanceLoading
                    }
                    onDatesChange={({ startDate, endDate }) =>
                      this.handleCategoryBalanceDateChange(startDate, endDate)
                    }
                    focusedInput={this.state.focusedInput}
                    onFocusChange={(focusedInput) =>
                      this.setState({ focusedInput })
                    }
                    startDatePlaceholderText="Fecha Inicio"
                    endDatePlaceholderText="Fecha Fin"
                    small
                    isOutsideRange={() => false}
                    hideKeyboardShortcutsPanel
                    minimumNights={0}
                  />
                </Col>
                <Col md="7">
                  {this.state.startDate && this.state.endDate ? (
                    <Row>
                      <Col md="12">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainReportExport}
                          minWidth={800}
                        />
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainDetailedReportExport}
                          minWidth={800}
                          detailed={true}
                        />
                      </Col>
                    </Row>
                  ) : null}
                </Col>
              </Row>
              <hr className="my-4" />
              {startDate != null && endDate != null ? (
                <Row>
                  <Col>
                    <Row className="mb-2">
                      <Col>
                        <b>Total de Ventas (S/):</b>{" "}
                        {formatHelper.toMoney(totalBought)}
                      </Col>
                    </Row>
                    <Row>
                      {categorySellsError && (
                        <Col xs="12">
                          <Alert color="danger">{categorySellsError}</Alert>
                        </Col>
                      )}
                      <Col>
                        <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                          {this.renderDataTable(
                            columns.columnsCategorySellsXS,
                            categorySells,
                            this.state.pageSells,
                            categorySellsTotal,
                            categorySellsPageSize,
                            categorySellsLoading,
                            this.handleSellsPageChange
                          )}
                        </MediaQuery>
                        <MediaQuery
                          minWidth={layout.SM_MIN_WIDTH}
                          maxWidth={layout.MD_MAX_WIDTH}
                        >
                          {this.renderDataTable(
                            columns.columnsCategorySellsSM,
                            categorySells,
                            this.state.pageSells,
                            categorySellsTotal,
                            categorySellsPageSize,
                            categorySellsLoading,
                            this.handleSellsPageChange
                          )}
                        </MediaQuery>
                        <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                          {this.renderDataTable(
                            columns.columnsCategorySellsMD,
                            categorySells,
                            this.state.pageSells,
                            categorySellsTotal,
                            categorySellsPageSize,
                            categorySellsLoading,
                            this.handleSellsPageChange
                          )}
                        </MediaQuery>
                      </Col>
                    </Row>
                    <hr className="my-4" />
                    <Row>
                      {categoryBalanceError && (
                        <Col xs="12">
                          <Alert color="danger">{categoryBalanceError}</Alert>
                        </Col>
                      )}
                      <Col>
                        <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                          {this.renderDataTable(
                            columns.columnsCategoryBlanceXS,
                            categoryBalance,
                            this.state.page,
                            categoryBalanceTotal,
                            categoryBalancePageSize,
                            categoryBalanceLoading,
                            this.handlePageChange
                          )}
                        </MediaQuery>
                        <MediaQuery minWidth={layout.SM_MIN_WIDTH}>
                          {this.renderDataTable(
                            columns.columnsCategoryBlanceSM,
                            categoryBalance,
                            this.state.page,
                            categoryBalanceTotal,
                            categoryBalancePageSize,
                            categoryBalanceLoading,
                            this.handlePageChange
                          )}
                        </MediaQuery>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col>
                    <Alert color="info">
                      Seleccione un rango de fechas para visualizar los datos
                    </Alert>
                  </Col>
                </Row>
              )}
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { categorySellsBalanceList, categoryBalanceList } = state.report;

  return {
    categorySells: selectCategoryBalance(state),
    categorySellsLoading: categorySellsBalanceList.loading,
    categorySellsTotal: categorySellsBalanceList.total,
    categorySellsPageSize: categorySellsBalanceList.pageSize,
    categorySellsError: categorySellsBalanceList.error,
    totalBought: categorySellsBalanceList.totalBought,

    categoryBalance: categoryBalanceList.categoryBalance,
    categoryBalanceTotal: categoryBalanceList.total,
    categoryBalancePageSize: categoryBalanceList.pageSize,
    categoryBalanceError: categoryBalanceList.error,
    categoryBalanceLoading: categoryBalanceList.loading,
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCategoryBalance,
      getCategorySellsBalance,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryBalance);



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/CategoryBalance/CategoryBalance.js